import React from 'react';
import './CategorySection.css';

const CategorySection = () => {
  const categories = [
    {
      id: 'products',
      name: "Our Collection",
      image: 'https://images.unsplash.com/photo-1622445275576-721325763afe?w=600',
      description: 'Stylish and comfortable t-shirts for everyone'
    }
  ];

  return (
    <section className="section category-section" id="categories">
      <div className="container">
        <h2 className="section-title">Shop by Category</h2>
        <p className="section-subtitle">Find the perfect t-shirt for your style</p>
        
        <div className="categories-grid">
          {categories.map(category => (
            <div key={category.id} className="category-card">
              <div className="category-image" style={{ backgroundImage: `url(${category.image})` }}>
                <div className="category-overlay">
                  <h3>{category.name}</h3>
                  <p>{category.description}</p>
                  <button 
                    onClick={() => document.getElementById(category.id)?.scrollIntoView({ behavior: 'smooth' })}
                    className="btn btn-primary"
                  >
                    Shop {category.name}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
